import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions/index';
import moment from 'moment';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import Logo from '../graphics/Logo';
import Icon from '../graphics/Icon';
import styled from 'styled-components';
import ios from '../../assets/appledownload.png';
import android from '../../assets/googledownload.png';

const FooterWrapper = styled.div`
 position: fixed;
  background: #0066ff;
  height: 62px;
  display: flex;
  align-items: center;
  color: #fff;
  font-weight: 400;
  bottom: 0;
  width: 100%;
  font-size: 15px;
  box-shadow: 0px -2px 4px rgba(0,0,0,.2);
  z-index: 600;
  flex-wrap: nowrap;
  justify-content: space-between;

  .logo div {
    padding: 0 20px;

    img {
      max-width: 100000px;
    }
  }
`;
const Copyright = styled.div`
  height: 28px;
  line-height: 32px;
  .inner {
    border-right: 1px solid #40B4E5;
    margin-right: 20px;
    padding-right: 20px;
    white-space: nowrap;
  }
`;
const Alert = styled.div`
  height: 62px;
  max-width: 55%;
  flex: 1;
  .inner {
    margin-right: 20px;
    height: 62px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
  .alertText {
    height: auto;
    display: flex;
    align-items: center;
  }
  .text {
    line-height: 1em;
  }
  .arrow {
    margin-left: 15px;
    cursor: pointer;
    float: right;

    &:hover g g {
      fill: #FF9700;
    }
  }
  a {
    color: #fff;
    text-decoration: underline;
  }
  p {
    display: inline;
  }
`;
const LeftSide = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;
const RightSide = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const Group = styled.div`

  div {
    border-left: 1px solid #40B4E5;
    padding-right: 15px;
    padding-left: 15px;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
  }
  img {
    height: 30px;
    vertical-align: middle;
    margin: 0 7px;
    max-width: 100000px;
  }
  .icon {
    margin: 0 8px;
  }
  g {
    fill: #fff;
  }
`;


class Footer extends PureComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {

  }
  goToLocation = (item) => {
    const { onSetHover, onAddItem, onChangeMap } = this.props;
    if (item.url) {
      window.open(item.url, '_blank');
    } else {
      onSetHover(item.id);
      onAddItem(item);
      onChangeMap({
        center: {
          lat: item.lat,
          lng: item.lng
        },
        zoom: 15
      });
    }
  }
  renderAlerts() {
    const { results, news } = this.props;
    var alerts = [], today = moment();
    if (news && news.length > 0) {
      news.map(newsItem => {
        var a = {};
        var dateTo = new Date(newsItem.dateTo);
        var dateFrom = new Date(newsItem.dateFrom);
        if (moment(today).isBetween(dateFrom, dateTo)) {
          a = { ...newsItem };
          a.headline = newsItem.title ? newsItem.title : 'News: ';
          a.message = newsItem.content;
          alerts.push(a);
        }
      });
    }
    results.map(result => {
      var numAlerts = result.currentAlerts.length;
      if (numAlerts > 0) {
        for (let i=0; i<numAlerts; i++) {
          var a = {};
          a = { ...result };
          a.headline = (result.name1 && result.name2) ? result.name1 + ' - ' + result.name2 : result.title;
          a.message = result.currentAlerts[i].Comments;
          alerts.push(a);
        }
      }
    });
    if (alerts.length > 1) {
      const settings = {
        autoplay: true,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true
      };
      var alertText = alerts.map((alert, i) => {
        return (
          <div className="inner" key={i}>
            <div className="alertText">
              <div className="text">
                <b>{alert.headline}</b>  <span dangerouslySetInnerHTML={{__html: alert.message}}></span>
              </div>
              <div className="arrow" onClick={() => this.goToLocation(alert)}><Icon name="next" /></div>
            </div>
          </div>
        );
      });
      return (
        <Slider {...settings}>
          {alertText}
        </Slider>
      );
    } else if (alerts.length === 1) {
      return (
        <div className="inner">
          <div className="alertText">
            <div className="text">
              <b>{alert.headline}</b>  <span dangerouslySetInnerHTML={{__html: alerts[0].message}}></span>
            </div>
            <div className="arrow" onClick={() => this.goToLocation(alerts[0])}><Icon name="next" /></div>
          </div>
        </div>
      );
    } else {
      return '';
    }
  }
  render() {
    return (
      <FooterWrapper>
        <LeftSide>
          <div className="logo"><a href="https://healthebay.org/" target="_blank"><Logo logo="htb" /></a></div>
          <Copyright><div className="inner">&copy; 2018 Beach Report Card</div></Copyright>
          <Alert>
            {this.renderAlerts()}
          </Alert>
        </LeftSide>
        <RightSide>
          <Group>
            <div className="inner">
              <a href="http://twitter.com/beachreportcard" target="_blank"><Icon name="twitter" /></a>
              <a href="https://www.instagram.com/healthebay/" target="_blank"><Icon name="instagram" /></a>
              <a href="https://www.facebook.com/HealtheBay/" target="_blank"><Icon name="facebook" /></a>
            </div>
          </Group>
          <Group>
            <div className="inner">
              <a href="https://itunes.apple.com/us/app/beach-report-card/id472446703" target="_blank"><img src={ios} alt="iOS app" /></a>
              <a href="https://play.google.com/store/apps/details?id=org.healthebay.brc" target="_blank"><img src={android} alt="Android app" /></a>
            </div>
          </Group>
        </RightSide>
      </FooterWrapper>
    );
  }
}
const mapStateToProps = state => {
  return {
    results: state.brc.results,
    news: state.brc.news
  };
};

export default connect(mapStateToProps, { ...Actions })(Footer);


// WEBPACK FOOTER //
// ./src/components/static/Footer.js